import { render, staticRenderFns } from "./inline-reviews.vue?vue&type=template&id=38f04674&"
import script from "./inline-reviews.vue?vue&type=script&lang=js&"
export * from "./inline-reviews.vue?vue&type=script&lang=js&"
import style0 from "./inline-reviews.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports